import { OutOfBounds } from "../components/playing-surface/playing-surface";
import { Sport } from "../redux/slices";
import { BasketballCourtView, SportPlay } from "../types";

export const getOutofBounds = (play: SportPlay): OutOfBounds => {
  const { sport } = play;

  switch (sport) {
    case Sport.BASKETBALL: {
      const { playSurfaceView } = play;

      const { outOfBoundsEnd, outOfBoundsLeft, outOfBoundsRight } = play.properties;

      const left = outOfBoundsLeft ? 5 : 0;
      const right = outOfBoundsRight ? 5 : 0;

      const top = (() => {
        switch (playSurfaceView) {
          case BasketballCourtView.FRONTCOURT:
          case BasketballCourtView.FULLCOURT:
            return outOfBoundsEnd ? 5 : 0;
          case BasketballCourtView.BACKCOURT:
            return 0;
        }
      })();

      const bottom = (() => {
        switch (playSurfaceView) {
          case BasketballCourtView.FRONTCOURT:
            return 0;
          case BasketballCourtView.BACKCOURT:
          case BasketballCourtView.FULLCOURT:
            return outOfBoundsEnd ? 5 : 0;
        }
      })();

      return { top, right, bottom, left };
    }

    case Sport.HOCKEY:
      return { top: 0, right: 0, bottom: 0, left: 0 };

    case Sport.SOCCER: {
      const { outOfBounds } = play;
      if (outOfBounds) return { top: 5, right: 5, bottom: 5, left: 5 };
      else return { top: 0, right: 0, bottom: 0, left: 0 };
    }
  }
};
